import { Search, SlidersHorizontal, FolderInput } from "lucide-react";
export const SearchSection = () => (
  <section id="semantic-search" className="recruit-discovery recruit-section">
    <div className="recruit-shell">
      <div className="recruit-split-heading">
        <div>
          <p className="recruit-eyebrow">01 / Find a starting point</p>
          <h2>
            Your next shortlist starts
            <br />
            with a better search.
          </h2>
        </div>
        <p>
          Describe the experience you need. Combine semantic resume search with filters, or evaluate
          resumes against the criteria that matter for your role.
        </p>
      </div>
      <div className="recruit-discovery-bar">
        <span>
          <Search size={19} /> Describe the experience
        </span>
        <span>
          <SlidersHorizontal size={19} /> Refine your criteria
        </span>
        <span>
          <FolderInput size={19} /> Bring your own resumes
        </span>
      </div>
      <figure className="recruit-product-capture">
        <img
          src="/images/marketing/demo-resume-workflow.png"
          alt="Actual theRecruit demo workspace showing Talent Pool, Resume Matches, Applicants, AI Interviews, resume upload, filters and custom ranking controls. Candidate records are outside the crop."
          width={1264}
          height={550}
          loading="lazy"
        />
        <figcaption>
          <span className="recruit-signal-dot" /> Inside the product · Demo workspace · Cropped to
          exclude candidate records
        </figcaption>
      </figure>
      <p className="recruit-feature-note">
        Discovery uses resume relevance. Role criteria and source-linked answers support the next
        steps of your review—they are not a single blended score.
      </p>
    </div>
  </section>
);
